export default __webpack_public_path__ + "static/media/secr-lock.5a0853ef.svg";